import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Comment } from "./useTaskAddCommentMutation";
import { invalidateTaskRelatedQueries } from "@/utils/cacheInvalidation";

type TaskCreateCommentResponseType = ResponseType<Comment>;

function useTaskStatusUpdateMutation(taskId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<TaskCreateCommentResponseType>["response"],
    AxiosResponseAndError<TaskCreateCommentResponseType>["error"],
    { status: string; taskId?: string; projectId?: string }
  >({
    mutationFn: (data) => {
      return ApiRequest.put<TaskCreateCommentResponseType>(
        `${requestURLs.task}status/${taskId ? taskId : data.taskId}`,
        data
      );
    },
    onSuccess: (_, variables) => {
      const targetTaskId = variables.taskId || taskId;
      void invalidateTaskRelatedQueries(queryClient, {
        taskId: targetTaskId,
        projectId: variables.projectId,
      });
    },
  });

  return mutation;
}

export default useTaskStatusUpdateMutation;
